<div class="expedite-disbursement" *transloco="let t">
	<op-masthead [title]="t('TERMS_CONFIRMED.loanTermsConfirmed')"></op-masthead>
	<div class="main-panel" *ngIf="loaded">
		<div class="op-gray op-mb-10">
			<div class="op-label-font op-mb-5">{{ t('EXPEDITE_DISBURSEMENT.approvedLoanAmount') }}</div>
			<div class="op-black-bold op-header-3-font">
				{{ loanApp.loanTerms.loanAmount | currency: 'USD':'symbol':'0.2' }}
			</div>
		</div>
		<div class="op-gray op-mb-10">
			<div class="op-label-font op-mb-5">{{ t('EXPEDITE_DISBURSEMENT.currentFundingMethod') }}</div>
			<div class="op-black-bold op-body-2-font">
				{{ t('EXPEDITE_DISBURSEMENT.' + loanApp.disbursement.disbursementType) }}
			</div>
		</div>
		<div class="op-gray">
			<div class="op-label-font op-mb-5">{{ t('EXPEDITE_DISBURSEMENT.youWillReceiveFunds') }}</div>
			<div class="delivery-note op-mtb-6">
				<mat-icon svgIcon="op-attention-orange"></mat-icon>
				<div
					class="op-ml-5 op-body-2-bold-font op-black"
					*ngIf="loanApp.disbursement.disbursementType === disbursementType.check"
				>
					<span>{{ t('DISBURSEMENT_SELECTION.DEBIT_CARD.SWITCH.in5To7BusinessDays') }}</span>
				</div>
				<div
					class="op-ml-5 op-body-2-bold-font op-black"
					*ngIf="loanApp.disbursement.disbursementType === disbursementType.ach"
				>
					<span>{{ t('DISBURSEMENT_SELECTION.DEBIT_CARD.SWITCH.in1To3BusinessDays') }}</span>
				</div>
			</div>
			<div
				class="delivery-method op-label-font"
				*ngIf="loanApp.disbursement.disbursementType === disbursementType.check && mailingAddress"
			>
				{{ mailingAddress }}
			</div>
			<div
				class="delivery-method op-label-font"
				*ngIf="loanApp.disbursement.disbursementType === disbursementType.ach && disbursementAccount"
			>
				{{ t('DISBURSEMENT_SELECTION.BANK_ACCOUNT.TYPE.' + disbursementAccount.accountType) }}
				({{ disbursementAccount.accountNumber | opLastNNumber: '.':3 }})
			</div>
		</div>
		<div class="op-black-bold" *ngIf="switchToDebitCardEligible || switchToACHEligible">
			<p>
				<span>{{ t('EXPEDITE_DISBURSEMENT.currentFundingSelection') }}</span>
				<span class="delivery-emphasis">{{ t('EXPEDITE_DISBURSEMENT.isNotTheFastest') }}</span>
			</p>
		</div>
		<ng-container *ngIf="switchToDebitCardEligible">
			<div class="expedite-note">
				<mat-icon svgIcon="op-stars"></mat-icon>
				<span class="op-body-2-bold-font">{{
					'EXPEDITE_DISBURSEMENT.switchToDebitCardToGetFunds'
						| transloco: { amount: (loanApp.loanTerms.loanAmount | currency: 'USD':'symbol':'0.2') }
				}}</span>
			</div>
			<div class="expedite-actions op-mb-8">
				<button mat-flat-button color="primary" (click)="switchToDebitCard()">
					{{ t('EXPEDITE_DISBURSEMENT.switchToDebitCard') }}
				</button>
			</div>
		</ng-container>
		<ng-container *ngIf="switchToACHEligible">
			<div class="expedite-note">
				<mat-icon svgIcon="op-stars"></mat-icon>
				<span class="op-body-2-bold-font">{{
					'EXPEDITE_DISBURSEMENT.switchToDirectDepositToGetFunds'
						| transloco: { amount: (loanApp.loanTerms.loanAmount | currency: 'USD':'symbol':'0.2') }
				}}</span>
			</div>
			<div class="expedite-actions op-mb-8">
				<button mat-flat-button color="primary" (click)="switchToDirectDeposit()">
					{{ t('EXPEDITE_DISBURSEMENT.switchToDirectDeposit') }}
				</button>
			</div>
		</ng-container>

		<div class="expedite-actions op-mb-8" (click)="continueOnlineProcess()">
			<a> {{ t('EXPEDITE_DISBURSEMENT.continueWithCurrentFundingMethod') }}</a>
		</div>
	</div>
	<div *ngIf="switchToDebitCardEligible" class="op-gray op-body-2-font op-mt-20">
		{{ t('EXPEDITE_DISBURSEMENT.debitCardDisclaimer') }}
	</div>
</div>
